export default __webpack_public_path__ + "static/Perfil-goex-7b63975e-b6f6d6c741b312e41982a7411892b09b.webp";